export default __webpack_public_path__ + "static/media/ani-finik.7e00d65b.gif";